import PropTypes from 'prop-types';
import React from 'react';
import ScrollLock from 'react-scrolllock';
import classNames from 'classnames';

const ScreenOverlay = ({ children, isTransparent }) => (
    <ScrollLock>
        <div className={classNames('dashboard-screen-overlay', { 'dashboard-transparent': isTransparent })}>
            {children}
        </div>
    </ScrollLock>
);

ScreenOverlay.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    isTransparent: PropTypes.bool,
};

ScreenOverlay.defaultProps = {
    children: [],
    isTransparent: false,
};

export default ScreenOverlay;
